(function () {
  let loadScript = (scriptObj, callback) => {
    let script = document.createElement('script');
    script.crossOrigin = scriptObj.cors;
    script.integrity = scriptObj.integrity;
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }
    script.src = scriptObj.url;
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  const checkTdcDate = () => {
    $('.tdc-cart-button').prop('disabled', !$('#tdc-cart-date').val());
  };

  const initTdcCart = ($) => {
    loadScript(
      {
        url: '//code.jquery.com/ui/1.12.1/jquery-ui.min.js',
        integrity: 'sha256-VazP97ZCwtekAsvgPBSUwPFKdrwD3unUfSGVYrahUqU=',
        cors: 'anonymous',
      },
      function () {
        initDatePicker();
      }
    );
    // $('.ajax-cart__toggle').click(() => checkTdcDate());
    $('#tdc-cart-date').change(() => checkTdcDate());
  };

  const initDatePicker = () => {
    const cd = cutoffProps.day;
    const nd = cutoffProps.day - 1;
    const minDate = moment().hour() >= cutoffProps.hour ? cd : nd;
    const maxDate = `+${cutoffProps.futureDays}d`;
    $('#tdc-cart-date').datepicker('destroy');
    $('#tdc-cart-date').datepicker({
      dateFormat: 'dd/mm/yy',
      minDate: minDate,
      maxDate: maxDate,
      beforeShowDay: function (date) {
        const day = moment(date).day();
        const longDate = moment(date).format('DD/MM/YYYY');
        // return [day !== 0 && !cutoffProps.closedDays.includes(longDate)];
        return [!cutoffProps.closedDays.includes(longDate)];
      },
    });
  };

  if (typeof jQuery === 'undefined' || parseFloat(jQuery.fn.jquery) < 2.2) {
    loadScript(
      {
        url: '//code.jquery.com/jquery-3.5.1.slim.min.js',
        integrity: 'sha256-4+XzXVhsDmqanXGHaHvgh1gMQKX40OUvDEBTu8JcmNs=',
        cors: 'anonymous',
      },
      function () {
        jQueryVersion = jQuery.noConflict(true);
        initTdcCart(jQueryVersion);
      }
    );
  } else {
    jQueryVersion = jQuery;
    initTdcCart(jQueryVersion);
  }
})();
